import MetlinkUploaderComponent from "../Components/MetlinkUploader/MetlinkUploaderComponent";

const MetlinkUploaderPage = () => {
  return (
    <div>
      <MetlinkUploaderComponent />
    </div>
  );
};

export default MetlinkUploaderPage;
